<template>
  <div id="app">
    <heading ref='header'></heading>
    <div class="app_update_button_container">
      <button class="update-alert" v-if="updateAvailable" @click="refreshApp">
        New update available! Click to update.
      </button>
    </div>
    <router-view :key="user_doc?user_doc.id:null" />
    <!-- <router-view :else-if="!user_doc && !$route.meta.requiresAuth"  />
    <router-view :else-if="!user_doc && $route.meta.requiresNoUserDoc" /> -->
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
export default {
  name: "App",
  components: {
    'heading': Header
  },
  data() {
    return {
      refreshing: false,
      registration: null,
      updateAvailable: false,
    }
  },
  created() {
    document.addEventListener("swUpdate", this.showUIUpdate, { once: true });
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        // To prevent infinite loop refresh
        if (this.refreshing) return;

        this.refreshing = true;
        window.location.reload();
      });
    }
  },
  methods: {
    showUIUpdate(e) {
      this.registration = e.detail;
      this.updateAvailable = true;
    },
    refreshApp() {
      this.updateAvailable = false;

      if (!this.registration || !this.registration.waiting) {
        return;
      }

      this.registration.waiting.postMessage("skipWaiting");
    },
  },
};
</script>

<style lang='scss' src="../public/css/main.scss"></style>
